import { useEffect, useEffectEvent } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { CanopyPlayer } from "@src/pages/CanopyPlayer";
import { LitePlayer } from "@src/pages/LitePlayer";
import { liteRedirect } from "@src/pages/LiteRedirect/liteRedirect";
import { Player } from "@src/pages/Player";

import { useRadioSession } from "@src/hooks/useRadioSession";

import { usePlayerState } from "@src/states/player";

import { onlyDigits } from "@src/utils/onlyDigits";

export function PlayerRenderer() {
  // changeTrack global event
  useEffect(() => {
    const unsubscribe = usePlayerState.subscribe((state, prevState) => {
      const hasPrevTrack =
        prevState.currentTrack.artist && prevState.currentTrack.title;
      const prevTrack = `${prevState.currentTrack.artist} - ${prevState.currentTrack.title}`;
      const currentTrack = `${state.currentTrack.artist} - ${state.currentTrack.title}`;
      if (hasPrevTrack && prevTrack !== currentTrack) {
        console.log("changeTrack");
        document.dispatchEvent(new Event("changeTrack"));
      }
    });
    return () => {
      unsubscribe();
    };
  }, []);

  // Habilita o acesso pela URI /[cnpj]
  // Por exemplo: https://fabricca.pro/07687928002189
  const params = useParams();
  const navigate = useNavigate();
  const autoRedirect = useEffectEvent(() => {
    if (!params.idRadio) {
      return;
    }

    if (params.idRadio === "lite") {
      // https://fabricca.pro/lite/wishpiscina/07687928000305/?pwa=1
      // {"idRadio":"lite","cnpj":"wishpiscina","senha":"07687928000305"}
      const idRadio = params.cnpj;
      const cnpj = params.senha;
      const path = `${idRadio}/${cnpj}/`.replace("//", "/"); // caso o cnpj seja vazio
      liteRedirect(path);
      return;
    }

    const cnpj = onlyDigits(params.idRadio);
    if (cnpj.length === 14) {
      navigate(`/portal?findBy=cnpj&cnpj=${cnpj}`);
    }
  });
  useEffect(() => {
    autoRedirect();
  }, [params.idRadio, navigate]);

  useRadioSession();

  const liteMode = window.location.search.includes("lite=1");
  if (liteMode) {
    return <LitePlayer />;
  }

  // https://fabricca.pro/canopybyhilton?popup=1
  const canopyMode =
    window.location.pathname.includes("canopybyhilton") &&
    window.location.search.includes("popup=1");
  if (canopyMode) {
    return <CanopyPlayer />;
  }

  const raspberryMode = window.location.search.includes("lite=2");
  if (raspberryMode) {
    return <Player raspberry={true} />;
  }

  return <Player />;
}
